import { MessageKey } from "../message-key.js";
export const en = {
    [MessageKey.accountAlreadyConfirmed]: `Account already confirmed.`,
    [MessageKey.accountAlreadyExists]: `Account already exists and is confirmed.`,
    [MessageKey.accountConfirmed]: `Account confirmed successfully! You can now sign in.`,
    [MessageKey.accountCreated]: `Account created. A confirmation email was sent.`,
    [MessageKey.accountData]: `Authenticated account data.`,
    [MessageKey.accountNotConfirmed]: `Please confirm your account to continue.`,
    [MessageKey.accountNotFound]: `Account not found.`,
    [MessageKey.accountPendingConfirmation]: `Account already exists but is not confirmed.`,
    [MessageKey.confirmationEmailSent]: `Confirmation email sent.`,
    [MessageKey.confirmationTooSoon]: `Confirmation email sent recently. Try again later.`,
    [MessageKey.confirmationTryAfterMinutes]: `Account not confirmed yet, try to login again in {minutes} minutes to receive another confirmation link`,
    [MessageKey.healthOk]: `Service is healthy.`,
    [MessageKey.incorrectOldPassword]: `Old password is incorrect.`,
    [MessageKey.internalServerError]: `Internal server error.`,
    [MessageKey.invalidCredentials]: `Email or password is incorrect.`,
    [MessageKey.invalidEmail]: `Invalid email address.`,
    [MessageKey.loginSuccessful]: `You’re logged in.`,
    [MessageKey.logoutSuccessful]: `Logged out successfully.`,
    [MessageKey.notAuthenticated]: `You must sign in to continue.`,
    [MessageKey.passwordChanged]: `Password changed successfully.`,
    [MessageKey.passwordReset]: `Password reset successfully.`,
    [MessageKey.resetEmailSent]: `If the account exists and is confirmed, a reset email has been sent.`,
    [MessageKey.resetTokenInvalid]: `Invalid reset token.`,
    [MessageKey.resetTokenMissing]: `Reset token not found. Request a new one.`,
    [MessageKey.resetTooSoon]: `Reset email sent recently. Try again later.`,
    [MessageKey.routeNotFound]: `Route not found.`,
    [MessageKey.sessionInvalid]: `Your session has expired. Please sign in again.`,
    [MessageKey.tokenMismatch]: `Confirmation token mismatch.`,
    [MessageKey.tokenNotFound]: `Confirmation token not found.`,
    [MessageKey.invalidTurnstileToken]: `Invalid Turnstile token.`,
    [MessageKey.missingTurnstileToken]: `Missing Turnstile token.`,
    [MessageKey.turnstileVerificationFailed]: `Turnstile verification failed.`,
    [MessageKey.accountPreferences]: `User preferences.`,
    [MessageKey.accountPreferencesUpdated]: `User preferences updated.`,
    [MessageKey.accountProfileUpdated]: `Account profile updated.`,
    [MessageKey.forbiddenOrigin]: `Forbidden: origin not allowed`,
    [MessageKey.forbiddenOriginSecret]: `Forbidden: invalid or missing origin secret`,
};
//# sourceMappingURL=en.js.map